var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16600_178393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.470002 7.53014C-0.154997 6.90514 -0.154997 5.89014 0.470002 5.26514C1.095 4.64014 2.11 4.64014 2.735 5.26514L8 10.5351L13.27 5.27014C13.895 4.64514 14.91 4.64514 15.535 5.27014C16.16 5.89514 16.16 6.91014 15.535 7.53514L10.265 12.8001L15.53 18.0701C16.155 18.6951 16.155 19.7101 15.53 20.3351C14.905 20.9601 13.89 20.9601 13.265 20.3351L8 15.0651L2.73 20.3301C2.105 20.9551 1.09 20.9551 0.465002 20.3301C-0.159998 19.7051 -0.159998 18.6901 0.465002 18.0651L5.735 12.8001L0.470002 7.53014Z",
    fill: "#71717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16600_178393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 25.6,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.264c337986078314bf533ee237eddfed.svg";
export { ForwardRef as ReactComponent };